import React from "react";
import { Layout } from "antd";
import { useSelector } from "react-redux";
import urlParameters from "../utils/urlParameters";

const urlLogoAccount = "https://account-logo.sankhya.com.br/sankhyaid-logo.png";

const { Header } = Layout;

export default props => {
    const { isLoading } = useSelector(state => state.loading);

    const isHide = () => {
        let url = window.location.href;
        let parameters = urlParameters(url);

        if (parameters["hide"] === "true") {
            return true;
        }
        return null;
    }

    const receiveMessage = event => {
        if (event.data === "Logout SankhyaId" && event.type === "message") {            
            let SankhyaHub = window['SankhyaHub'];
            SankhyaHub.logout();
        }
    }

    window.addEventListener("message", receiveMessage, false);

    return (
        // <Header style={{padding: "unset", display: isLoading ? "none" : "unset"}}>
        <Header style={{ padding: "unset" }}>
            <sankhya-hub id="hub" background={"#FFF"} applicationId={props.applicationId} brandUrl={urlLogoAccount} hide={isHide()} />
        </Header>
    )
}
